import SubdomainSite from "@/subdomains/SubdomainSite";
import config from "@/subdomains/configs/metals";

/** Metals page — metals.bizlem.com */
export default function MetalsPage() {
  return <SubdomainSite config={config} />;
}

export { config };
